export default function PostCommentsFormEdit() {
	return 'Post Comments Form Placeholder';
}
